import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';

import { getSortedMealsForDay, presentServiceTime } from './functions';
import { 
  OPEN_DLG_SERVICETIME, 
  selectMeals 
} from './reducer';
import styles from './DayView.module.css';

const DayView = ({ day, renderMenu }) => {

  const dispatch = useDispatch();

  /* const selector = useCallback(selectMeals, []);
  const meals = useSelector(selector); */
  const meals = useSelector(selectMeals);
  const sortedMeals = useMemo(() => getSortedMealsForDay(day, meals), [ day, meals ]);
  // TODO check logic 개선 
  const isPublished = useMemo(() => sortedMeals.some(
      meal => meal.menu.some(menu => menu.published)), [ sortedMeals ]);

  const handleClickAddServiceTime = useCallback(evt => {
    const dateValue = evt.currentTarget.getAttribute('data-date');
    const serviceTimeValue = evt.currentTarget.getAttribute('data-servicetime');

    dispatch({
      type: OPEN_DLG_SERVICETIME,
      payload: {
        date: dateValue,
        serviceTime: serviceTimeValue,
        target: 'serviceTime'
      }
    });
  }, []);

  const handleClickAddMenu = useCallback(evt => {
    const dateValue = evt.currentTarget.getAttribute('data-date');
    const serviceTimeValue = evt.currentTarget.getAttribute('data-servicetime');

    dispatch({
      type: OPEN_DLG_SERVICETIME,
      payload: {
        date: dateValue,
        serviceTime: serviceTimeValue,
        target: 'menu'
      }
    });
  }, []);

  return (
    <div className={styles.dayView}>
      {sortedMeals.map((el, i) => (
        <div 
          key={i}
          className={styles.meal}
        >
          <ServiceTime 
            serviceTime={el.serviceTime}
          />
          {el.menu.map((menu, j) => (
            <div key={j}>
              {renderMenu(day, el.serviceTime, menu)}
            </div>
          ))}
          {/* {!isPublished && el.menu.length > 0 && */}
          {el.menu.length > 0 &&
          <MenuPlaceholder
            date={el.date}
            serviceTime={el.serviceTime}
            onClick={handleClickAddMenu}
          />}
          {/* {!isPublished && el.menu.length == 0 &&  */}
          {el.menu.length == 0 && 
          <ServiceTimePlaceholder
            date={el.date}
            serviceTime={el.serviceTime}
            onClick={handleClickAddServiceTime}
          />}
        </div>
      ))}
    </div>
  );
}

const ServiceTime = ({ serviceTime }) => {

  let text = presentServiceTime(serviceTime);

  return (
    <div className={styles.serviceTime}>
      {text} 
    </div>
  );
}

const ServiceTimePlaceholder = ({ date, serviceTime, onClick }) => {

  return (
    <div className={styles.servicePlaceholder}>
      <Button
        className={styles.addItemButton}
        onClick={onClick}
        data-date={date}
        data-servicetime={serviceTime}
        size="small"
      >
        서비스 타임 추가하기 
      </Button>
    </div>
  )
}

const MenuPlaceholder = ({ date, serviceTime, onClick }) => {

  // TODO pricing info 
  
  return (
    <div className={styles.menuPlaceholder}>
      <Button
        className={styles.addItemButton}
        onClick={onClick}
        data-date={date}
        data-servicetime={serviceTime}
        size="small"
      >
        메인메뉴 추가하기
      </Button>
    </div>
  );
}

export default DayView;